document.addEventListener("DOMContentLoaded", function() {
  
    const searchToggleButtons = document.querySelectorAll('.js-toggle-search');
    const searchInput = document.querySelector('#search-input-desktop');
    const searchOverlay = document.querySelector('.search-overlay');
    if (searchOverlay !== null) {
        searchToggleButtons.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                toggleSearch();
            });
        })
    }

    const toggleSearch = () => {
        searchOverlay.classList.toggle('is-visible');
        document.body.classList.toggle('has-search-active');
        if (document.body.classList.contains('has-search-active')) {
            searchInput.focus();
        };
    }

});